import { render, staticRenderFns } from "./sidebar_item.vue?vue&type=template&id=0166c366&"
import script from "./sidebar_item.vue?vue&type=script&lang=js&"
export * from "./sidebar_item.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports